// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { QueryClient } from '@tanstack/react-query';

export const DEFAULT_POLL_INTERVAL = 2500;

export const queryClient = (pollingEnabled?: boolean) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: pollingEnabled,
        refetchInterval: pollingEnabled ? DEFAULT_POLL_INTERVAL : false,
        keepPreviousData: true,
      },
      mutations: {
        retry: 1,
      },
    },
  });
